import { render } from "./DynvibeDynamicTable.vue?vue&type=template&id=5ef26d62&scoped=true"
import script from "./DynvibeDynamicTable.vue?vue&type=script&lang=js"
export * from "./DynvibeDynamicTable.vue?vue&type=script&lang=js"

import "./DynvibeDynamicTable.vue?vue&type=style&index=0&id=5ef26d62&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef26d62"]])

export default __exports__